import { AgentPermission } from './types';
import { AgentPermissionMatrix } from './AgentPermissionMatrix';

export interface PermissionsTabProps {
  permissions: AgentPermission[];
  onChange: (permissions: AgentPermission[]) => void;
}

export function PermissionsTab({ permissions, onChange }: PermissionsTabProps) {
  return (
    <div className="space-y-4">
      <AgentPermissionMatrix permissions={permissions} onChange={onChange} />
    </div>
  );
}
